import { Link } from 'react-router-dom';
import { heroComics } from '@/mocks/comics';

export default function HeroSection() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20artistic%20abstract%20background%20with%20warm%20orange%20golden%20and%20coral%20gradient%20tones%2C%20subtle%20manga%20panel%20grid%20patterns%20fading%20in%20the%20background%2C%20soft%20glowing%20particles%2C%20modern%20minimalist%20aesthetic%2C%20clean%20composition%2C%20no%20text%2C%20no%20characters%2C%20atmospheric%20warm%20lighting&width=1600&height=900&seq=hero-bg-manga&orientation=landscape"
          alt="43423漫画网"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-200 text-xs md:text-sm font-medium mb-4 md:mb-6 backdrop-blur-sm border border-primary-400/30">
          每日更新 · 海量免费漫画
        </span>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-3 md:mb-4 tracking-wide">
          43423<span className="text-primary-300">漫画网</span>
        </h1>
        <p className="text-sm md:text-lg text-white/80 max-w-2xl mb-6 md:mb-8 leading-relaxed">
          韩漫 · 日漫 · 国漫 · 免费漫画大全，下拉式流畅阅读，随时随地畅享漫画世界
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <Link
            to="/category/tuijian"
            onClick={scrollToTop}
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-full font-semibold text-sm transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            开始阅读
          </Link>
          <Link
            to="/category/paihang"
            onClick={scrollToTop}
            className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white rounded-full font-semibold text-sm backdrop-blur-sm border border-white/30 transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            热门排行
          </Link>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}